/*
 * Copyright (c) 2024, WSO2 Inc. (http://www.wso2.org) All Rights Reserved.
 *
 * WSO2 Inc. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 *
 *
 */
import React from 'react';
import { TableRow } from '@material-ui/core';
import CopyToClipBoardWithTooltip from './CopyToClipBoardWithTooltip'

export default function CopyToClipboardRow(props) {
    const text = props.text;

    return <TableRow>{text}
        <CopyToClipBoardWithTooltip text={text} />
    </TableRow>
}
